type TSearchParamValue = string | number | null | undefined;

export function buildSearchString(params: Record<string, TSearchParamValue>) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    searchParams.set(key, String(value));
  });

  const searchString = searchParams.toString();

  return searchString ? `?${searchString}` : '';
}
